import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from './authentication.service';
import { MessageService } from 'primeng/api';

import { Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class CryptoJsService {
  private authService: AuthenticationService;
  private messageService: MessageService;

  constructor(
    private injector: Injector,
    private router: Router,
  ) {
    setTimeout(() => {
      this.authService = this.injector.get(AuthenticationService);
      this.messageService = this.injector.get(MessageService);
    });
  }

  Encrypt(text: string) {
    let _key = CryptoJS.enc.Utf8.parse("/<du3]@D33Asr3@X");
    let _iv = CryptoJS.enc.Utf8.parse("/<du3]@D33Asr3@X");
    let encrypted = CryptoJS.AES.encrypt(
      text, _key, {
      keySize: 128,
      iv: _iv,
      mode: CryptoJS.mode.CBC,
    });
    return encrypted.toString();
  }

  // encryption and decryption methods for payloads (involving clent side and server side)
  EncryptPayload(text: string) {
    let encyCode: any;
    if(environment.staging) {
      encyCode = '/<N]%PNf#B'
    } else if(environment.production) {
      encyCode = '/>Z{%oHa#A'
    }
    const now = new Date();
    const year = now.getUTCFullYear().toString().slice(-2); // Last 2 digits of the year
    const month = String(now.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(now.getUTCDate()).padStart(2, '0');
    const hour = String(now.getUTCHours()).padStart(2, '0');
    const min = String(now.getUTCMinutes());
    const sec = String(now.getUTCSeconds());
    const msec = String(now.getUTCMilliseconds());

    const utcTime = `${year}${month}${day}`;
    let result = Number(utcTime) * 7412


    let numericVal = result.toString().slice(-6);

    let encCode = encyCode.concat(numericVal);
    let text2 = btoa(unescape(encodeURIComponent(text)));

    var _key = CryptoJS.enc.Utf8.parse(encCode);

    let encrypted = CryptoJS.AES.encrypt(
      text2, _key, {
      keySize: 128,
      // iv: _iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    // this.DecryptDataPayload(encrypted.toString())
    return encrypted.toString();
  }

  DecryptDataPayload(encryptedText: string) {
    if (encryptedText == null) {
      return JSON.stringify(null);
    }
    // let encyCode = '/>Z{%oHa#A';
    let encyCode: any;
    if(environment.staging) {
      encyCode = '/<N]%PNf#B';
    } else if(environment.production) {
      encyCode = '/>Z{%oHa#A'
    }

    const now = new Date();
    const year = now.getUTCFullYear().toString().slice(-2); // Last 2 digits of the year
    const month = String(now.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(now.getUTCDate()).padStart(2, '0');

    const utcTime = `${year}${month}${day}`;
    // const utcTime = `250125`
    let result = Number(utcTime) * 7412;
    let numericVal = result.toString().slice(-6);

    let encCode = encyCode.concat(numericVal);
    var _key = CryptoJS.enc.Utf8.parse(encCode);

    let decrypted = CryptoJS.AES.decrypt(
      encryptedText, _key, {
      keySize: 128,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);

    return decodeURIComponent(escape(atob(decrypted)));
  }

  DecryptToken(encryptedText: string) {
    if (encryptedText == null) {
      return JSON.stringify(null);
    }

    let encyCode: any;
    if(environment.staging) {
      encyCode = '/N<i[C@K&F#A25@2';
    } else if(environment.production) {
      encyCode = '/M<i]C@A#D&A25@1';
    }

    var _key = CryptoJS.enc.Utf8.parse(encyCode);

    let decrypted;
    try {
      decrypted = CryptoJS.AES.decrypt(
        encryptedText, _key, {
        keySize: 128,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }).toString(CryptoJS.enc.Utf8);
    } catch (error) {
      // Assuming you have a TopbarComponent with a logout method

      this.logOut();
      return JSON.stringify(null);
    }

    return decodeURIComponent(escape(atob(decrypted)));
  }

  DecryptData(obj: any) {
    let _key = CryptoJS.enc.Utf8.parse("/<du3]@D33Asr3@X");
    let _iv = CryptoJS.enc.Utf8.parse("/<du3]@D33Asr3@X");

    let decrypted = CryptoJS.AES.decrypt(
      obj, _key, {
      keySize: 128,
      iv: _iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);
    return decrypted.toString(CryptoJS.enc.Utf8);
  }


  // Only UI based encryption and decryption methods
  EncryptSessionD(text: string) {
    let encyCode = '$?Z#%yS3@F';
    const now = new Date();
    const year = now.getUTCFullYear().toString().slice(-2);
    const month = String(now.getUTCMonth() + 1).padStart(2, '0');
    const day = String(now.getUTCDate()).padStart(2, '0');
    const hour = String(now.getUTCHours()).padStart(2, '0');
    const min = String(now.getUTCMinutes());
    const sec = String(now.getUTCSeconds());
    const msec = String(now.getUTCMilliseconds());

    const utcTime = `${year}${month}${day}`;
    let result = Number(utcTime) * 9687;


    let numericVal = result.toString().slice(-6);

    let encCode = encyCode.concat(numericVal);
    let text2 = btoa(unescape(encodeURIComponent(text)));

    var _key = CryptoJS.enc.Utf8.parse(encCode);

    let encrypted = CryptoJS.AES.encrypt(
      text2, _key, {
      keySize: 128,
      // iv: _iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  }

  DecryptSessionD(encryptedText: string) {
    if (encryptedText == null) {
      return JSON.stringify(null);
    }

    try {
      let encyCode = '$?Z#%yS3@F';
      const now = new Date();
      const year = now.getUTCFullYear().toString().slice(-2);
      const month = String(now.getUTCMonth() + 1).padStart(2, '0');
      const day = String(now.getUTCDate()).padStart(2, '0');

      const utcTime = `${year}${month}${day}`;
      // const utcTime = `250125`
      let result = Number(utcTime) * 9687;
      let numericVal = result.toString().slice(-6);

      let encCode = encyCode.concat(numericVal);
      var _key = CryptoJS.enc.Utf8.parse(encCode);

      let decrypted = CryptoJS.AES.decrypt(
        encryptedText, _key, {
        keySize: 128,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }).toString(CryptoJS.enc.Utf8);

      return decodeURIComponent(escape(atob(decrypted)));
    }
    catch (error) {
      this.logOut();
      return JSON.stringify(null);
    }
  }

  EncryptSession(text: string) {
    let encyCode = '${Z/%yS0#I';
    const now = new Date();
    const year = now.getUTCFullYear().toString().slice(-2);
    const month = String(now.getUTCMonth() + 1).padStart(2, '0');
    const day = String(now.getUTCDate()).padStart(2, '0');
    const hour = String(now.getUTCHours()).padStart(2, '0');
    const min = String(now.getUTCMinutes());
    const sec = String(now.getUTCSeconds());
    const msec = String(now.getUTCMilliseconds());

    const utcTime = `${year}${month}${day}`;
    let result = Number(utcTime) * 9687;


    let numericVal = result.toString().slice(-6);

    let encCode = encyCode.concat(numericVal);
    let text2 = btoa(unescape(encodeURIComponent(text)));

    var _key = CryptoJS.enc.Utf8.parse(encCode);

    let encrypted = CryptoJS.AES.encrypt(
      text2, _key, {
      keySize: 128,
      // iv: _iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  }

  DecryptSession(encryptedText: string) {
    if (encryptedText == null) {
      return JSON.stringify(null);
    }

    try {
      let encyCode = '${Z/%yS0#I';
      const now = new Date();
      const year = now.getUTCFullYear().toString().slice(-2);
      const month = String(now.getUTCMonth() + 1).padStart(2, '0');
      const day = String(now.getUTCDate()).padStart(2, '0');

      const utcTime = `${year}${month}${day}`;
      // const utcTime = `250125`
      let result = Number(utcTime) * 9687;
      let numericVal = result.toString().slice(-6);

      let encCode = encyCode.concat(numericVal);
      var _key = CryptoJS.enc.Utf8.parse(encCode);

      let decrypted = CryptoJS.AES.decrypt(
        encryptedText, _key, {
        keySize: 128,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }).toString(CryptoJS.enc.Utf8);

      return decodeURIComponent(escape(atob(decrypted)));
    }
    catch (error) {
      this.logOut();
      return JSON.stringify(null);
    }
  }

  logOut() {
    this.messageService.add({
      severity: 'warn',
      summary: 'Session Expired',
      detail: 'Auto Logout',
    });
    // window.sessionStorage.removeItem('farmerDetails');
    // sessionStorage.removeItem('farmerPh');
    // sessionStorage.removeItem('userID');
    // sessionStorage.removeItem('farmerPh');
    // sessionStorage.removeItem('isFarmerLogin');
    // sessionStorage.removeItem('isAtalBhujal');
    // sessionStorage.removeItem('dataF');
    sessionStorage.clear();
    this.getInitialToken();
    setTimeout(() => { this.router.navigate(['/home']) }, 2500);
  }

  getInitialToken() {
    this.authService.getInitialToken().subscribe((response: any) => {
      if (response) {
        sessionStorage.setItem("token", response.data)
      }
    })
  }
}
